import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenSeedlingUpdateAction from './communityGardenSeedlingUpdate.action.json' with { type: 'json' }
import { communityGardenSeedlingObject } from '../../communityGardenSeedlingObject'

const communityGardenSeedlingUpdateDefinition = defineAction({
  ...communityGardenSeedlingUpdateAction,

  input: communityGardenSeedlingObject.pick({
    id: true,
    type: true,
    quantity: true,
  }),
  output: z.object({}),
})

export default communityGardenSeedlingUpdateDefinition
